var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4609 39.9922C16.9141 37.3672 23.0938 36.0547 29 36.0547C34.9062 36.0547 41.0312 37.3672 47.375 39.9922C53.8281 42.5078 57.0547 45.8438 57.0547 50V57.0547H0.945312V50C0.945312 45.8438 4.11719 42.5078 10.4609 39.9922ZM38.8438 24.8984C36.1094 27.6328 32.8281 29 29 29C25.1719 29 21.8906 27.6328 19.1562 24.8984C16.4219 22.1641 15.0547 18.8828 15.0547 15.0547C15.0547 11.2266 16.4219 7.94531 19.1562 5.21094C21.8906 2.36719 25.1719 0.945312 29 0.945312C32.8281 0.945312 36.1094 2.36719 38.8438 5.21094C41.5781 7.94531 42.9453 11.2266 42.9453 15.0547C42.9453 18.8828 41.5781 22.1641 38.8438 24.8984Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.1633368a.svg";
export { ForwardRef as ReactComponent };